import { Guid } from 'guid-typescript';

export class FixedAssetDepriciationModel {
  id: Guid;
  fundId: Guid;
  amount: number;
}

export class FixedAssetExplainModel {
  id: Guid;
  name: string;
  referenceTypeId?: number;
  bookAccountId?: Guid;
  referenceId?: Guid;
  methodTypeId?: number;
  rate?: number;
  isDepreciable: boolean;
  invoiceTypeId?: number;
  accumulatedDepreciationAmount?: number;
  isAutoDepreciate: boolean;
  entryDate?: string;
  depreciationUptoDate?: string;
  depriciationStartDate?: string;
}

export class FixedAssetDepreciationModel {
  id: Guid;
  fundId: Guid;
  amount: number;
  name: string;
  acquiredDate: string;
  lastDepreciate?: string;
  entryDate: string;
  totalAmount: number;
  totalDepreciation: number;
  bookValue: number;
  journalId: Guid;
  accountingPeriodId: Guid;
  fixedAssetExplainId: Guid;
  rate: number;
  method: string;
  methodTypeId: number;
  isTangible?:boolean;
}

export class FixedAssetDisposeModel {
  id: Guid;
  fundId: Guid;
  name: string;
  referenceTypeId: number;
  bookAccountId: Guid;
  referenceId: Guid;
  methodTypeId?: number;
  rate?: number;
  isDepreciable: boolean;
  totalAmount: number;
  totalDepreciation: number;
  currentDepreciation: number;
  entryDate: string;
  isDisposed: boolean;
  disposalType?: number;
  disposeDate?: string;
  amountSold?: number;
  amountLoss?: number;
  description: string;
  transactionAccountId?: Guid;
  disposeJournalId?: Guid;
  transactionJournalId?: Guid;
  isVATApplicable: boolean;
  vatRateId?: Guid;
  vatAmount?: number;
  netAmount?: number;
  isTangible?:boolean;
}
